import { useState } from 'react';
import { faqs } from '@/mocks/gossip';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 py-10 md:py-14 bg-background-100/70">
      <div className="container-site grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-1.5 rounded-full bg-accent-500"></span>
              <span className="text-xs font-medium tracking-widest text-foreground-500">FAQ</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              吃瓜前，<span className="text-primary-600">先看这里</span>
            </h2>
            <p className="mt-3 text-foreground-600 leading-relaxed">
              关于内容来源、立场与勘误机制的常见问题，一次说清楚。
            </p>
            <a href="#footer" className="mt-5 inline-flex items-center gap-1.5 h-10 px-5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition whitespace-nowrap">
              还有疑问？联系我们 <i className="ri-mail-send-line"></i>
            </a>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={f.question} className="rounded-xl border border-background-200 bg-background-50 overflow-hidden">
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-background-50 transition"
                  >
                    <span className={`text-base font-semibold ${open ? 'text-primary-700' : 'text-foreground-900'}`}>{f.question}</span>
                    <span className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition ${open ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'}`}>
                      <i className={open ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </span>
                  </button>
                  <div className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.answer}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}